import { darken, ThemeOptions } from "@mui/material";

import { getInvertColor } from "utils/themeUtils";
import { convertHexToRGBA } from "utils/commonUtils";

import { legacyColors } from "../colors";

export const buttonOverrides: ThemeOptions["components"] = {
	MuiButton: {
		styleOverrides: {
			root: ({ ownerState: { fullWidth, "data-useremunit": useRemUnit }, theme }) => ({
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				gap: useRemUnit === "true" ? "0.4rem" : "4px",

				padding: useRemUnit === "true" ? "0.8rem 1.6rem" : "8px 16px",
				minWidth: "fit-content",
				width: fullWidth ? "100%" : "fit-content",
				height: useRemUnit === "true" ? "4rem" : "40px",
				textTransform: "none",
				fontFamily: "Nunito",
				fontWeight: 800,
				fontSize: useRemUnit === "true" ? "1.6rem" : "16px",
				lineHeight: 1,
				borderRadius: useRemUnit === "true" ? "0.8rem" : "8px",

				":disabled": {
					pointerEvents: "all",
					cursor: "not-allowed",
				},
				"&:disabled svg path": {
					fill: theme.palette.grey["400"],
				},
			}),

			contained: ({ ownerState: { color }, theme }) => {
				const mainColor = theme.palette[`${color}`]?.main;

				return {
					color: getInvertColor(mainColor),

					"&:disabled, &:disabled:hover": {
						color: theme.palette.grey["400"],
						backgroundColor: theme.palette.grey["200"],
					},
					":hover": {
						backgroundColor: darken(mainColor, 0.3),
					},
					"& svg path": {
						fill: getInvertColor(mainColor),
					},
					"&:disabled svg path": {
						fill: theme.palette.grey["400"],
					},
				};
			},

			outlined: ({ ownerState: { "data-useremunit": useRemUnit, color }, theme }) => {
				const mainColor = theme.palette[`${color}`]?.main;
				const isLight = getInvertColor(mainColor) === "#3C4255";

				return {
					border: `${useRemUnit === "true" ? "0.1rem" : "1px"} solid ${isLight ? "#3C4255" : mainColor}`,
					color: isLight ? "#3C4255" : mainColor,

					":hover, :disabled": {
						borderWidth: useRemUnit === "true" ? "0.1rem" : "1px",
					},
					"& svg path": {
						fill: isLight ? "#3C4255" : mainColor,
					},
				};
			},

			approve: ({ ownerState: { "data-useremunit": useRemUnit } }) => ({
				color: "#3C4255",
				backgroundColor: convertHexToRGBA(legacyColors.primary.main, 0.15),
				border: `${useRemUnit === "true" ? "0.1rem" : "1px"} solid ${legacyColors.primary.main}`,

				":hover": {
					backgroundColor: convertHexToRGBA(legacyColors.primary.main, 0.3),
				},
				":hover, :disabled": {
					border: `${useRemUnit === "true" ? "0.1rem" : "1px"} solid ${legacyColors.primary.main}`,
				},
				"& svg path": {
					fill: "#3C4255",
				},
			}),

			reject: ({ ownerState: { "data-useremunit": useRemUnit }, theme }) => ({
				color: "#3C4255",
				backgroundColor: theme.palette.common.white,
				border: `${useRemUnit === "true" ? "0.1rem" : "1px"} solid #F34236`,

				":hover": {
					backgroundColor: theme.palette.common.white,
				},
				":hover, :disabled": {
					border: `${useRemUnit === "true" ? "0.1rem" : "1px"} solid #F34236`,
				},
				"& svg path": {
					fill: "#3C4255",
				},
			}),

			complete: ({ ownerState: { "data-useremunit": useRemUnit }, theme }) => ({
				color: "#3C4255",
				backgroundColor: "#C4E4C5",
				// @ts-ignore
				border: `${useRemUnit === "true" ? "0.1rem" : "1px"} solid ${theme.palette.legacySuccess.main}`,

				":hover": {
					backgroundColor: darken("#C4E4C5", 0.3),
				},
				":hover, :disabled": {
					// @ts-ignore
					border: `${useRemUnit === "true" ? "0.1rem" : "1px"} solid ${theme.palette.legacySuccess.main}`,
				},
				"& svg path": {
					fill: "#3C4255",
				},
			}),

			startIcon: ({ ownerState: { "data-useremunit": useRemUnit } }) => ({
				marginRight: 0,
			}),
		},
	},
};
